// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC1m6sB52H0xfnq_lwvRghtctxNDhTKn6Y",
  authDomain: "ieeepublisher.firebaseapp.com",
  databaseURL: "https://ieeepublisher-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ieeepublisher",
  storageBucket: "ieeepublisher.firebasestorage.app",
  messagingSenderId: "70063779348",
  appId: "1:70063779348:web:1e2898ac6346bda90e0101",
  measurementId: "G-Q9V41PN3JG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getDatabase(app); 